// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__l2Gll","dialog_header":"styles_dialog_header__ERwHB","dialog_content":"styles_dialog_content__n3iu7"};